document.querySelectorAll('.guide-choice-box').forEach(function (box) {
  var tabs = box.querySelectorAll('.guide-choice-box__tab');

  function syncAriaSelected() {
    tabs.forEach(function (tab) {
      var input = document.getElementById(tab.getAttribute('for'));
      tab.setAttribute('aria-selected', input && input.checked ? 'true' : 'false');
    });
  }

  box.querySelectorAll('.guide-choice-box__input').forEach(function (input) {
    input.addEventListener('change', syncAriaSelected);
  });

  syncAriaSelected();
});
